export const theme = {
  colors: {
    primary: "#3B82F6",
    white: "#ffffff",
    darkBackground: "#0F172A",
    neonCyan: "#22D3EE",
    lightGrayText: "#94A3B8",
    gray: "#6B7280",
  },
  borderRadius: "20px",
};
